// Copyright 2016 Sorama B.V.

import { CaptureDevice, FrontEnd } from "datatypes/SoramaLocalApi";
import { ObjectExtensions } from "extensions/ObjectExtensions";
import { IIndexableObject } from "libraries/IndexedDb/IIndexableObject";
import { IHardwareDevice } from "services/Hardware/Datatypes/IHardwareDevice";

export class DecimationProperties {
    public decimationNormalisationProperties: number;
    public fixedPointFraction: number;
}

export interface MicrophoneArrayRackId {
    [microphoneArrayRackId: string]: string[];
}

/**
 * Defines a single device (Frontend + connected Capture Devices + Rack information) that can be used in a measurement setup.
 */
export class MeasurementDevice implements IHardwareDevice, IIndexableObject {
    //#region Properties

    //#region IHardwareDevice, IIndexableObject members
    public get id(): string {
        return this.frontEnd ? this.frontEnd.id : undefined;
    }

    public get name(): string {
        return this.frontEnd ? this.frontEnd.name : undefined;
    }

    public userId: string;
    //#endregion

    // Frontend of this Measurement Device
    public frontEnd: FrontEnd;

    // Capture devices in this Measurement Device
    public captureDevices: CaptureDevice[];

    // Dictionary where the keys are the Id's of the Microphone Array Racks and the values are the ids of the microphone arrays in that rack at the time of storage
    public microphoneArrayRackIds: MicrophoneArrayRackId;

    public decimationProperties: DecimationProperties;
    //#endregion

    constructor(
        frontEnd: FrontEnd,
        captureDevices: CaptureDevice[],
        microphoneArrayRackIds?: MicrophoneArrayRackId,
        decimationProperties?: DecimationProperties,
        userId?: string
    ) {
        this.frontEnd = frontEnd;
        this.captureDevices = captureDevices;
        this.microphoneArrayRackIds = microphoneArrayRackIds;
        this.userId = userId;
        this.decimationProperties = decimationProperties;
    }

    public static copy(obj: MeasurementDevice): MeasurementDevice {
        if (!obj) return obj;

        return new MeasurementDevice(
            obj.frontEnd !== undefined ? <FrontEnd>ObjectExtensions.copy(obj.frontEnd) : undefined,
            obj.captureDevices !== undefined ? <CaptureDevice[]>ObjectExtensions.copy(obj.captureDevices) : undefined,
            obj.microphoneArrayRackIds !== undefined
                ? <MicrophoneArrayRackId>ObjectExtensions.copy(obj.microphoneArrayRackIds)
                : undefined,
            obj.decimationProperties !== undefined
                ? <DecimationProperties>ObjectExtensions.copy(obj.decimationProperties)
                : undefined,
            obj.userId
        );
    }
}
